function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(5 1)"
}, React.createElement("rect", {
  width: 13.75,
  height: 21.083,
  rx: 2
}), React.createElement("path", {
  d: "M13.75 17L0 17M5 2L9.58333333 2M7.22916667 19C7.35573192 19 7.45833333 19.1026014 7.45833333 19.2291667 7.45833333 19.3557319 7.35573192 19.4583333 7.22916667 19.4583333 7.10260141 19.4583333 7 19.3557319 7 19.2291667 7 19.1026014 7.10260141 19 7.22916667 19"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1.04348em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/phone.2b4eab72.svg";
export { SvgComponent as ReactComponent };